var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1445(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 265.938,
    height: 241.377,
    viewBox: "0 0 265.938 241.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22b7bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41a1c8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.915,
    y1: 0.213,
    x2: 0.139,
    y2: 0.903,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f8bf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41a1c8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.193,
    y1: 0.115,
    x2: 0.86,
    y2: 1,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1445",
    "data-name": "Group 1445",
    transform: "translate(-808.877 -1869.398)",
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M536.239,522.237l8.5,2.958,5.916.37-.37-5.177-12.2-3.609Z",
    transform: "translate(381.657 1512.897)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M688.279,656.131s0,5.177.739,5.177,10.723-1.109,13.681,0,7.4-2.958,5.177-5.177-5.838-5.546-8.1-4.807-11.5,2.588-11.5,2.588Z",
    transform: "translate(240.524 1377.893)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M639.9,651.4s-4.437,8.874-1.479,9.614a10.259,10.259,0,0,0,6.656-.74c.37-.37,5.546-1.849,6.286-1.109s.739-2.958.739-2.958Z",
    transform: "translate(261.724 1377.818)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1441",
    "data-name": "Group 1441",
    transform: "translate(888.284 2021.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M502.341,532.978a9.3,9.3,0,0,0,4.047-.137c.2-.063.428-.2.408-.407a.5.5,0,0,0-.092-.2,12.584,12.584,0,0,1-1.223-2.329.2.2,0,0,0-.075-.106.193.193,0,0,0-.13,0c-.6.157-1.113.542-1.706.707a2.425,2.425,0,0,1-.929.069c-.269-.031-.636-.253-.88-.224C501.9,531.238,502.237,532.069,502.341,532.978Z",
    transform: "translate(-430.581 -493.743)",
    fill: "#2f8bf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M624.2,516.332a7.074,7.074,0,0,0,2.339-2.2.385.385,0,0,0,.063-.19.39.39,0,0,0-.075-.183,7.572,7.572,0,0,0-1.9-2.052,5.542,5.542,0,0,0-1.059.978c-.224.236-.844.611-.85.972,0,.2.236.44.346.611.149.22.289.444.424.672A7.975,7.975,0,0,1,624.2,516.332Z",
    transform: "translate(-526.892 -479.352)",
    fill: "#2f8bf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M476.651,541.39a.907.907,0,0,1-.163.591.8.8,0,0,1-.342.2c-1.889.677-4.076-.167-5.96.5-.387.136-.754.334-1.143.465a6.214,6.214,0,0,1-1.426.253c-.666.063-1.337.1-2.005.122a4.825,4.825,0,0,1-1.512-.132,1.816,1.816,0,0,1-1.16-.919.882.882,0,0,1-.057-.654.7.7,0,0,1,.124-.2,1.781,1.781,0,0,1,.444-.361l.695-.448a4.656,4.656,0,0,1,1.054-.558c.275-.09.566-.128.846-.2a5.741,5.741,0,0,0,2.415-1.8l.945-1.009a.949.949,0,0,1,.328-.263.912.912,0,0,1,.408-.039,5.449,5.449,0,0,1,2.578.864,3.342,3.342,0,0,0,.636.375,2.27,2.27,0,0,0,1.777-.22c.242-.13.19-.2.291-.436s.351-.381.566-.169a.6.6,0,0,1,.135.257,7.233,7.233,0,0,1,.126,2.1.927.927,0,0,0,.041.326,1.841,1.841,0,0,0,.185.3.706.706,0,0,1,.039.078A2.073,2.073,0,0,1,476.651,541.39Z",
    transform: "translate(-399.595 -499.426)",
    fill: "#514e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M476.651,554.98a.909.909,0,0,1-.163.591.8.8,0,0,1-.342.2c-1.889.677-4.076-.167-5.96.5-.387.136-.754.334-1.143.465a6.227,6.227,0,0,1-1.426.253c-.666.063-1.337.1-2.005.122a4.817,4.817,0,0,1-1.512-.133,1.816,1.816,0,0,1-1.16-.919.883.883,0,0,1-.057-.654.7.7,0,0,1,.124-.2c.11.23.19.536.259.646a1.323,1.323,0,0,0,.884.638,2.2,2.2,0,0,0,.815-.1c1.712-.424,3.531-.43,5.176-1.072a11.95,11.95,0,0,1,1.7-.652,13.309,13.309,0,0,1,1.834-.149c.966-.078,1.9-.369,2.853-.522A2.074,2.074,0,0,1,476.651,554.98Z",
    transform: "translate(-399.595 -513.017)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M609.422,521.031a3.435,3.435,0,0,1-1.043,1.859,12.143,12.143,0,0,0-1.461,1.6,12.867,12.867,0,0,1-1.345,2.307,3.675,3.675,0,0,1-.815.581,5.68,5.68,0,0,1-1.05.483,7.828,7.828,0,0,1-2.965.161,2.666,2.666,0,0,1-.941-.181,2.832,2.832,0,0,1-.391-.24,1.867,1.867,0,0,1-.611-.611.612.612,0,0,1-.059-.444,1.043,1.043,0,0,1,.283-.432,6.691,6.691,0,0,1,.718-.646,4.306,4.306,0,0,0,.933-.815,2.635,2.635,0,0,0,.361-.815,7.233,7.233,0,0,0,.263-1.559,4.948,4.948,0,0,1,.108-1.043c.151-.538.55-1.019.505-1.575a.393.393,0,0,1,.02-.239.332.332,0,0,1,.187-.116,3.313,3.313,0,0,1,.974-.226,1.135,1.135,0,0,1,.9.355c.139.167.23.408.434.473a.688.688,0,0,0,.31.012,2.6,2.6,0,0,0,1.426-.438,1.778,1.778,0,0,0,.591-1.3c0-.185-.083-.379.2-.408.216-.028.387.2.5.346a4.825,4.825,0,0,1,.954,1.736.517.517,0,0,1,.182-.035.788.788,0,0,1,.65.332A1.294,1.294,0,0,1,609.422,521.031Z",
    transform: "translate(-507.784 -484.176)",
    fill: "#514e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M609.723,528.923a3.434,3.434,0,0,1-1.043,1.858,12.153,12.153,0,0,0-1.461,1.6,12.858,12.858,0,0,1-1.345,2.307,3.693,3.693,0,0,1-.815.581,5.678,5.678,0,0,1-1.049.483,7.827,7.827,0,0,1-2.965.161,2.664,2.664,0,0,1-.941-.181,2.847,2.847,0,0,1-.391-.24,1.869,1.869,0,0,1-.611-.611,1.489,1.489,0,0,1,.611-.147c.44.025.762.44,1.184.569.6.181,1.2-.243,1.81-.387.4-.094.815-.069,1.209-.2a2.986,2.986,0,0,0,.894-.542,4.559,4.559,0,0,0,.956-.921,5.925,5.925,0,0,0,.56-1.119,16,16,0,0,1,1.133-2.168,1.53,1.53,0,0,1,.23-.3,3.2,3.2,0,0,1,.312-.226,2.369,2.369,0,0,0,.719-1.312,2.307,2.307,0,0,1,.161-.438.788.788,0,0,1,.65.332A1.293,1.293,0,0,1,609.723,528.923Z",
    transform: "translate(-508.085 -492.068)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M266.463,362.475v-2.531a7.026,7.026,0,0,0-7.026-7.024h-99.95a7.026,7.026,0,0,0-7.026,7.024v4.666Z",
    transform: "translate(-152.46 -352.92)",
    fill: "#33323d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 7.686,
    cy: 16.486,
    rx: 7.686,
    ry: 16.486,
    transform: "translate(87.303 2.409) rotate(-7.1)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M269.185,384.307v70.3a6.078,6.078,0,0,1-6.081,6.079H158.567a6.079,6.079,0,0,1-6.077-6.079V377.22c3,1.112,3,1.112,6.077,1.019H263.1A6.081,6.081,0,0,1,269.185,384.307Z",
    transform: "translate(-152.484 -372.268)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M269.185,388.689v70.3a6.081,6.081,0,0,1-6.081,6.079H158.567a6.079,6.079,0,0,1-6.077-6.079V381.6c3,1.111,3,1.111,6.077,1.019H263.1A6.081,6.081,0,0,1,269.185,388.689Z",
    transform: "translate(-152.484 -375.756)",
    fill: "#504f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M594.566,543.936v22.483h-21.8a11.242,11.242,0,1,1,0-22.484Z",
    transform: "translate(-478.163 -505.011)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M596.026,541v22.487h-21.8a11.242,11.242,0,1,1,0-22.484Z",
    transform: "translate(-479.326 -502.674)",
    fill: "#33323d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 4.383,
    cy: 4.383,
    r: 4.383,
    transform: "translate(91.559 45.785)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    cx: 4.383,
    cy: 4.383,
    r: 4.383,
    transform: "translate(91.856 45.19)",
    fill: "#2f8bf7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M674.126,635.407c-13.392,6.09-30.64,5.658-30.64,5.658H624.821V637.5c7.606-2.123,18.123-3.436,29.747-3.436a136.331,136.331,0,0,1,19.557,1.341Z",
    transform: "translate(294.432 1385.041)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M687.814,646.69c0,6.445-18.8,11.666-42,11.666s-42-5.22-42-11.666c0-3.214,4.678-6.124,12.249-8.23v3.564h18.665s17.247.432,30.64-5.658C678.715,638.314,687.814,642.2,687.814,646.69Z",
    transform: "translate(303.184 1384.082)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_835",
    "data-name": "Rectangle 835",
    width: 17.869,
    height: 17.901,
    transform: "translate(936.496 1958.136)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M661.812,549.775s1.479,5.177-1.109,5.547a10.1,10.1,0,0,0-4.437,1.849l4.807,6.286h8.874l5.546-5.547s-7.4-5.546-5.916-8.874S661.812,549.775,661.812,549.775Z",
    transform: "translate(281.329 1421.02)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M661.812,549.775s1.479,5.177-1.109,5.547a10.1,10.1,0,0,0-4.437,1.849l4.807,6.286h8.874l5.546-5.547s-7.4-5.546-5.916-8.874S661.812,549.775,661.812,549.775Z",
    transform: "translate(281.329 1421.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M645.344,630.48s-7.025,9.614-1.849,12.2,29.951,2.588,31.8,0,2.588-10.723,0-11.463S645.344,630.48,645.344,630.48Z",
    transform: "translate(287.443 1386.535)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M645.344,630.48s-7.025,9.614-1.849,12.2,29.951,2.588,31.8,0,2.588-10.723,0-11.463S645.344,630.48,645.344,630.48Z",
    transform: "translate(287.443 1386.535)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 8.504,
    cy: 8.504,
    rx: 8.504,
    ry: 8.504,
    transform: "translate(937.595 1956.374)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M648.025,562.86l7.4-1.479s1.849,5.916,7.765,4.807,7.4-4.807,7.4-4.807,4.437,1.849,4.807,1.849,5.177,1.849,5.177,2.958-5.546,12.2-5.546,12.2l.74,19.967-27.362-.74,1.849-19.6Z",
    transform: "translate(284.763 1415.33)",
    fill: "#2f8bf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M640.16,580.4s-2.219,19.6-.74,21.076,7.4,5.546,7.4,5.546v-4.437l-2.958-5.546,2.958-12.942Z",
    transform: "translate(288.56 1407.405)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M701.248,579.448s-1.294,20.152-1.294,20.892-3.328,3.328-4.437,3.328-1.849-1.849-1.849-1.849l2.588-2.958-1.849-15.16Z",
    transform: "translate(265.743 1407.801)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M688.358,625.009s16.639-9.244,17.009,0-8.5,12.942-8.5,12.942-22.925,6.874-23.85,4.362-2.773-6.58-1.294-6.95,3.328-1.109,4.067-.37,9.983-5.547,9.983-5.547Z",
    transform: "translate(275.12 1390.527)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M706.557,626.042a21.034,21.034,0,0,0-4.437,2.589c-1.109,1.109-5.916,2.958-5.916,2.958",
    transform: "translate(264.686 1388.384)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M645.918,564.657l-2.219-.74s-8.135,8.5-5.546,10.723,4.068,2.958,4.807,3.7,4.437,1.109,4.437,1.109Z",
    transform: "translate(289.089 1414.273)",
    fill: "#2f8bf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M694.407,568.354l3.328.74s2.588,5.546,3.328,6.286-1.109.37-2.219,1.849-2.219,4.068-4.437,4.068-5.177-3.7-5.177-3.7Z",
    transform: "translate(267.592 1412.424)",
    fill: "#2f8bf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M635.391,629.851s-14.051-9.984-18.858-2.588,20.707,17.379,24.4,18.858,7.025,2.958,7.025,2.958,3.328-8.135,3.328-9.614-2.588-1.479-3.328-1.479-4.067-.739-4.807-1.849S635.391,629.851,635.391,629.851Z",
    transform: "translate(298.137 1389.012)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M635.98,629.212s3.7,2.958,7.026,3.7,4.437,2.588,4.437,2.588",
    transform: "translate(289.782 1387.063)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M644.919,603.95l.3,15.656a1.96,1.96,0,0,0,1.982,1.923l29.134-.327a1.96,1.96,0,0,0,1.934-1.847l.884-15.329a1.96,1.96,0,0,0-1.957-2.073H646.879a1.96,1.96,0,0,0-1.959,2Z",
    transform: "translate(286.057 1398.423)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M638.457,545.137a36.569,36.569,0,0,0,2.368-5.248,23.194,23.194,0,0,0,.3-6.877,21.584,21.584,0,0,1,.516-6.068,10.431,10.431,0,0,1,3-5.222c3.875-3.459,10.967-3.708,15.7-2.268,1.865.568,3.853,1.649,4.315,3.543.07.286.1.581.179.865.388,1.41,1.83,2.3,2.351,3.669.673,1.768-.365,3.69-.5,5.577-.158,2.2.925,4.284,1.992,6.217a7.189,7.189,0,0,1,1.231,3.685,4.655,4.655,0,0,1-.637,2.031,7.746,7.746,0,0,1-6.507,3.73,4.083,4.083,0,0,1-2.438-.576,3.78,3.78,0,0,1-1.252-3.778,18.332,18.332,0,0,1,1.491-3.92c.169-.4.321-.8.461-1.2a8.274,8.274,0,1,0-5.458.926,11.209,11.209,0,0,1-.543,6.232,23.536,23.536,0,0,1-2.617,4.563,6.3,6.3,0,0,1-1.667,1.866,5.906,5.906,0,0,1-1.42.606,14.718,14.718,0,0,1-6.461.91,6.183,6.183,0,0,1-5.065-3.678A7.592,7.592,0,0,1,638.457,545.137Z",
    transform: "translate(289.15 1433.146)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 9.025,
    cy: 5.114,
    rx: 9.025,
    ry: 5.114,
    transform: "translate(936.662 1954.989)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 18.665,
    cy: 18.665,
    rx: 18.665,
    ry: 18.665,
    transform: "translate(960.429 1885.884)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173",
    "data-name": "Ellipse 173",
    cx: 18.665,
    cy: 18.665,
    r: 18.665,
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 830.288, 2035.107)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_171",
    "data-name": "Ellipse 171",
    cx: 16.363,
    cy: 16.363,
    rx: 16.363,
    ry: 16.363,
    transform: "translate(1020.35 1993.093)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_172",
    "data-name": "Ellipse 172",
    cx: 28.782,
    cy: 28.782,
    rx: 28.782,
    ry: 28.782,
    transform: "translate(830.72 1923.214)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    cx: 9.083,
    cy: 9.083,
    rx: 9.083,
    ry: 9.083,
    transform: "translate(909.305 1910.965)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 9.083,
    cy: 9.083,
    rx: 9.083,
    ry: 9.083,
    transform: "translate(1047.747 1923.214)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_186",
    "data-name": "Ellipse 186",
    cx: 5.538,
    cy: 5.538,
    rx: 5.538,
    ry: 5.538,
    transform: "translate(1015.957 1946.235)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 5.538,
    cy: 5.538,
    rx: 5.538,
    ry: 5.538,
    transform: "translate(888.284 1878.299)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 5.538,
    cy: 5.538,
    rx: 5.538,
    ry: 5.538,
    transform: "translate(1010.559 1884.572)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 4.308,
    cy: 4.308,
    rx: 4.308,
    ry: 4.308,
    transform: "translate(1048.768 1983.322)",
    fill: "#22b7bb",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 4.308,
    cy: 4.308,
    rx: 4.308,
    ry: 4.308,
    transform: "translate(857.611 1883.837)",
    fill: "#22b7bb",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 4.308,
    cy: 4.308,
    rx: 4.308,
    ry: 4.308,
    transform: "translate(834.445 1990.742)",
    fill: "#22b7bb",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 4.308,
    cy: 4.308,
    rx: 4.308,
    ry: 4.308,
    transform: "translate(853.303 1991.76)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 4.451,
    cy: 4.451,
    rx: 4.451,
    ry: 4.451,
    transform: "translate(923.022 1895.648)",
    fill: "#22b7bb",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 4.451,
    cy: 4.451,
    rx: 4.451,
    ry: 4.451,
    transform: "translate(1036.798 1941.081)",
    fill: "#22b7bb",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 4.451,
    cy: 4.451,
    rx: 4.451,
    ry: 4.451,
    transform: "translate(1023.541 1901.552)",
    fill: "#22b7bb",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 4.451,
    cy: 4.451,
    rx: 4.451,
    ry: 4.451,
    transform: "translate(1065.914 1945.531)",
    fill: "#22b7bb",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 4.451,
    cy: 4.451,
    rx: 4.451,
    ry: 4.451,
    transform: "translate(914.803 1869.398)",
    fill: "#22b7bb",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 4.451,
    cy: 4.451,
    rx: 4.451,
    ry: 4.451,
    transform: "translate(1000.898 1918.764)",
    fill: "#22b7bb",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 2.047,
    cy: 2.047,
    rx: 2.047,
    ry: 2.047,
    transform: "translate(1043.653 1978.19)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 2.047,
    cy: 2.047,
    rx: 2.047,
    ry: 2.047,
    transform: "translate(1045.7 1898.051)",
    fill: "#22b7bb",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 2.047,
    cy: 2.047,
    rx: 2.047,
    ry: 2.047,
    transform: "translate(1056.83 1912.657)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 2.047,
    cy: 2.047,
    rx: 2.047,
    ry: 2.047,
    transform: "translate(1019.447 1873.849)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_187",
    "data-name": "Ellipse 187",
    cx: 2.047,
    cy: 2.047,
    rx: 2.047,
    ry: 2.047,
    transform: "translate(1007.753 1943.484)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 2.047,
    cy: 2.047,
    rx: 2.047,
    ry: 2.047,
    transform: "translate(824.635 1993.72)",
    fill: "#22b7bb",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 2.047,
    cy: 2.047,
    rx: 2.047,
    ry: 2.047,
    transform: "translate(934.449 1883.837)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 2.047,
    cy: 2.047,
    rx: 2.047,
    ry: 2.047,
    transform: "translate(873.829 1894.394)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 2.047,
    cy: 2.047,
    rx: 2.047,
    ry: 2.047,
    transform: "translate(818.746 2010.889)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 2.047,
    cy: 2.047,
    rx: 2.047,
    ry: 2.047,
    transform: "translate(841.015 1984.476)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 2.047,
    cy: 2.047,
    rx: 2.047,
    ry: 2.047,
    transform: "translate(908.837 1896.004)",
    fill: "#2f8bf7",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_175",
    "data-name": "Ellipse 175",
    cx: 7.016,
    cy: 7.016,
    rx: 7.016,
    ry: 7.016,
    transform: "translate(839.272 2005.92)",
    fill: "#22b7bb",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 5.405,
    cy: 5.405,
    rx: 5.405,
    ry: 5.405,
    transform: "translate(868.424 1904.549)",
    fill: "#22b7bb",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M212.757,575.79a4.271,4.271,0,0,0-1.957-2.17,6.706,6.706,0,0,0-1.769-.721,4.328,4.328,0,0,0,1.135-.793,4.076,4.076,0,0,0,1.087-1.68,5.743,5.743,0,0,0,.244-2.034,6.2,6.2,0,0,0-.919-3.231,5.757,5.757,0,0,0-2.619-1.947,9.543,9.543,0,0,0-3.169-.642v-4.608l-2.786,1.8v2.812h-2.229v-2.956l-2.856-1.659v4.615H190.85l1.95,3.462a3.033,3.033,0,0,1,1.219.166.934.934,0,0,1,.453.432,3.585,3.585,0,0,1,.132,1.262v12.49a3.584,3.584,0,0,1-.132,1.255c-.091.188-.139.353-.355.454s-.223.094-.822.094h-.007l-2.438,3.461h6.06v4.615h2.856v-4.615h2.229v4.615h2.786v-4.644a13.2,13.2,0,0,0,4.137-.743,6.8,6.8,0,0,0,3.114-2.271,7.209,7.209,0,0,0,1.1-3.692,8.393,8.393,0,0,0-.376-3.13Zm-12.991-9.317h0v-.1h1.948c1.1,0,4.747-.378,4.808,2.709s-4.808,2.961-4.808,2.961h-1.948v-.238h0Zm0,8.8h2.229c.453,0,2.01.072,2.577.1a2.4,2.4,0,0,1,.68.125c.08.028.156.06.238.1a3.419,3.419,0,0,1,.961.5,2.03,2.03,0,0,1,.5.483,3.24,3.24,0,0,1,.557,1.781,2.592,2.592,0,0,1-.348,1.421,3.3,3.3,0,0,1-1.5,1.283,9.389,9.389,0,0,1-3.659.7h-2.229Z",
    transform: "translate(657.505 1377.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M73.966,48.34h0c-.093.007-.574.036-1.647.036-.853,0-1.459-.026-1.671-.036h0c-3.3-.145-5.758-.719-5.758-1.406s2.461-1.26,5.758-1.408v2.242c.216.016.833.052,1.686.052,1.024,0,1.536-.043,1.629-.051V45.528c3.29.147,5.745.72,5.745,1.406s-2.455,1.26-5.745,1.405h0Zm0-3.044V43.29h4.591V40.23h-12.5v3.06h4.591V45.3c-3.731.171-6.537.911-6.537,1.8s2.806,1.624,6.537,1.8v6.429h3.318V48.885c3.723-.171,6.524-.91,6.524-1.795s-2.8-1.623-6.524-1.8h0Zm0,0Z",
    transform: "translate(762.573 2013.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1443",
    "data-name": "Group 1443",
    transform: "translate(970.424 1909.055) rotate(-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M11.614,0c.076,0,.021.04.015.052-.071.148-.145.295-.218.441L6.4,10.531a.249.249,0,0,1-.059.1.2.2,0,0,1-.033-.1c-.035-.246-.068-.493-.1-.74q-.081-.589-.163-1.18c-.077-.553-.156-1.105-.233-1.657-.055-.394-.108-.787-.163-1.181-.078-.558-.158-1.117-.235-1.676-.017-.127-.014-.128-.123-.058L0,7.388c0-.036.038-.046.063-.061L5.369,3.961a.205.205,0,0,0,.107-.047L11.544.066C11.571.049,11.609.041,11.614,0Z",
    transform: "translate(5.276 0.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M11.846.01c-.005.041-.043.049-.07.066L5.708,3.925a.2.2,0,0,1-.107.047c-.079-.055-.158-.112-.238-.165L4.357,3.151l-1.4-.917c-.332-.218-.666-.433-1-.65Q1.171,1.068.385.55A2.209,2.209,0,0,1,0,.281,5.416,5.416,0,0,1,.608.257l8.606-.2L11.786,0C11.806,0,11.828-.005,11.846.01Z",
    transform: "translate(5.043 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M.03,3.4,5.315.046c.109-.069.106-.068.123.058.077.559.157,1.118.235,1.676.055.394.108.787.163,1.181.077.552.156,1.1.233,1.657q.082.59.163,1.18c.034.247.066.494.1.74a.2.2,0,0,0,.033.1c-.03.056-.057,0-.078-.008-.352-.176-.7-.356-1.054-.535L3.477,5.2.973,3.925q-.45-.229-.9-.46C.048,3.452.016,3.447,0,3.417Z",
    transform: "translate(5.246 4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M.263,7.117l-.03.019a2.409,2.409,0,0,1-.024-.424Q.1,3.4,0,.084C0,.063,0,.042,0,.021L.03,0h0A2.211,2.211,0,0,0,.415.27Q1.2.79,1.989,1.3c.332.218.666.433,1,.65l1.4.917,1.006.655c.081.053.159.11.238.165L.326,7.056C.3,7.071.268,7.081.263,7.117Z",
    transform: "translate(5.013 0.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M.029,9.8C-.028,9.781.015,9.75.023,9.731q.19-.474.385-.946L3.22,1.914,3.974.075C3.984.05,4,.025,4.006,0c.032.016.021.044.022.066q.063,1.964.124,3.928.049,1.535.1,3.071a.285.285,0,0,0,.006.036l-.031.019L.085,9.743C.063,9.757.034,9.765.029,9.8Z",
    transform: "translate(0 0.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M0,2.7c.005-.033.034-.041.056-.055L4.194.019,4.226,0l3.8,1.942L10.46,3.186c.025.014.056.021.073.049-.027.027-.059.013-.087.011L.063,2.7Z",
    transform: "translate(0.029 8.047)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1444",
    "data-name": "Group 1444",
    transform: "translate(1028.588 2003.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M203.331-17.484c.237.238.474.476.713.712q.661.656,1.325,1.31c.573.566,1.141,1.136,1.721,1.695a2.758,2.758,0,0,0,1.7.777,2.83,2.83,0,0,0,2.351-.842q1.816-1.789,3.626-3.586c.021-.021.039-.044.059-.066h2.36l-3.5,3.462c-.5.5-.994,1-1.506,1.484a4.3,4.3,0,0,1-2.255,1.134,4.477,4.477,0,0,1-4.075-1.252c-.983-.953-1.947-1.925-2.919-2.889l-1.96-1.939Z",
    transform: "translate(-200.947 17.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M199.489,435.144l.332-.329,2.2-2.18c.821-.812,1.635-1.631,2.467-2.433a4.281,4.281,0,0,1,2.327-1.166,4.487,4.487,0,0,1,4.057,1.288c1.181,1.158,2.352,2.326,3.528,3.489l1.313,1.3a.338.338,0,0,1,.024.033c-.031,0-.054,0-.077,0-.73,0-1.459,0-2.189,0a.188.188,0,0,1-.119-.048q-.784-.768-1.564-1.542c-.731-.722-1.457-1.449-2.2-2.163a2.734,2.734,0,0,0-1.707-.771,2.828,2.828,0,0,0-2.326.845q-1.656,1.634-3.309,3.271c-.125.124-.25.248-.378.369a.136.136,0,0,1-.083.038q-1.127,0-2.254,0Z",
    transform: "translate(-199.489 -421.692)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1445);
export default __webpack_public_path__ + "static/media/Group 1445.adfe679a291ecc0a80ec9e760e8bb9e6.svg";
export { ForwardRef as ReactComponent };